/** Marketing / offers / promotions feature reducers */
export async function loadMarketingReducers() {
  const [
    marketing,
    promoCodes,
    discounts,
    automatedMessages,
    directMessages,
    email,
    aiChatbotSettings,
    aiChatbotConversations,
  ] = await Promise.all([
    import('../reducers/MarketingReducers'),
    import('../reducers/PromoCodesReducer'),
    import('../reducers/DiscountReducers'),
    import('../reducers/AutomatedMessagesReducer'),
    import('../reducers/DirectMessagesReducer'),
    import('../reducers/EmailReducer'),
    import('../reducers/AiChatbotSettingsReducer'),
    import('../reducers/AiChatbotConversationsReducer'),
  ]);

  return {
    marketing: marketing.default,
    promoCodes: promoCodes.default,
    discounts: discounts.default,
    automatedMessages: automatedMessages.default,
    directMessages: directMessages.default,
    email: email.default,
    aiChatbotSettings: aiChatbotSettings.default,
    aiChatbotConversations: aiChatbotConversations.default,
  };
}
